var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel flex granary-panel" },
    [
      _vm._l(_vm.pplist, function (item) {
        return _c(
          "div",
          {
            key: item.item_name,
            staticClass: "item-box",
            on: { click: _vm.previewClick },
          },
          [
            _c("div", { staticClass: "item" }, [
              _c("img", {
                staticClass: "logo",
                attrs: { src: item.img, alt: "" },
              }),
              _c("div", { staticClass: "r-box" }, [
                _c("div", [_vm._v(_vm._s(item.item_name))]),
                _c("div", [
                  _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(item.value)),
                  ]),
                  _vm._v(" (" + _vm._s(item.unit) + ") "),
                ]),
              ]),
            ]),
          ]
        )
      }),
      _c("div", { staticClass: "bg-box" }),
      _c("div", { staticClass: "y-box", on: { click: _vm.previewClick } }, [
        _c("img", {
          attrs: { src: require("images/granary/pp/center-bg.png"), alt: "" },
        }),
        _c("div", { staticClass: "info-box" }, [
          _c("div", { staticStyle: { color: "#F3D013" } }, [
            _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.sfqVal))]),
            _vm._v(" " + _vm._s(_vm.sfqUnit) + " "),
          ]),
          _c("div", { staticClass: "title" }, [_vm._v("总产值")]),
        ]),
      ]),
      _c("image-preview2", {
        attrs: {
          show: _vm.imgpre,
          list: _vm.imglist,
          initialIndex: _vm.initialIndex,
          isVideo: true,
          videoUrl: _vm.videoUrl,
        },
        on: {
          "update:show": function ($event) {
            _vm.imgpre = $event
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }